import { FAILURE, POST, PUT, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

const BASE_URL =
  "https://gestiondeflota.boltrack.net/apiultimamillav3/api/meta-template";

const parseCampos = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value === "string" && value.trim().length > 0) {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }
  return [];
};

const normalizarMetaTemplate = (row) => {
  if (!row || typeof row !== "object") return null;
  return {
    id: row.id,
    nombre: row.nombre ?? "",
    descripcion: row.descripcion ?? null,
    campos: parseCampos(row.campos),
    idUsuarioWeb: row.idUsuarioWeb ?? null,
    habilitado: row.habilitado ?? 1,
    fechaProceso: row.fechaProceso ?? null,
  };
};

export async function obtenerListaMetaTemplate() {
  try {
    const { code, body, message } = await fetch(
      `${BASE_URL}/obtener-lista-meta-template`,
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify({}),
      }
    ).then((res) => res.json());

    if (code === SUCCESS) {
      const data = Array.isArray(body)
        ? body.map(normalizarMetaTemplate).filter((t) => t !== null)
        : [];
      return { error: false, data };
    }
    return { error: true, message, data: [] };
  } catch (err) {
    console.log("obtenerListaMetaTemplate err");
    console.log(err);
    return { error: true, message: err, data: [] };
  }
}

export async function crearMetaTemplate({
  nombre,
  descripcion,
  campos,
  esGlobal,
}) {
  try {
    const { code, body, message } = await fetch(
      `${BASE_URL}/crear-meta-template`,
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify({
          nombre,
          descripcion,
          campos,
          esGlobal,
        }),
      }
    ).then((res) => res.json());

    if (code === SUCCESS) {
      return { error: false, data: normalizarMetaTemplate(body), message };
    }
    if (code === FAILURE) {
      return { error: true, message };
    }
    return { error: true, message };
  } catch (err) {
    console.log("crearMetaTemplate err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function actualizarMetaTemplate({
  id,
  nombre,
  descripcion,
  campos,
  esGlobal,
}) {
  try {
    const { code, message } = await fetch(
      `${BASE_URL}/actualizar-meta-template`,
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify({ id, nombre, descripcion, campos, esGlobal }),
      }
    ).then((res) => res.json());

    if (code === SUCCESS) {
      return { error: false, message };
    }
    if (code === FAILURE) {
      return { error: true, message };
    }
    return { error: true, message };
  } catch (err) {
    console.log("actualizarMetaTemplate err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function deshabilitarMetaTemplate(id) {
  try {
    const { code, message } = await fetch(
      `${BASE_URL}/deshabilitar-meta-template`,
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify({ id }),
      }
    ).then((res) => res.json());

    if (code === SUCCESS) {
      return { error: false, message };
    }
    if (code === FAILURE) {
      return { error: true, message };
    }
    return { error: true, message };
  } catch (err) {
    console.log("deshabilitarMetaTemplate err");
    console.log(err);
    return { error: true, message: err };
  }
}
